const INFO = {
	main: {
		title: "Vonypet Porfolio",
		name: "Aralar Von M.",
		email: "von.maniquis.aralar@gmail.com",
		logo: "../logo.png",
	},
	main: {
		title: "Vonypet Porfolio",
		name: "Aralar Von M.",
		email: "von.maniquis.aralar@gmail.com",
		logo: "../logo.png",
	},
	socials: {
		twitter: "https://twitter.com/vonypeto",
		github: "https://github.com/vonypeto",
		linkedin: "https://www.linkedin.com/in/von-aralar-72176a154/",
		instagram: "https://instagram.com/vonypeto",
		stackoverflow: "#",
		facebook: "https://www.facebook.com/von.hakka",
	},
	languages: {
		frontend: [
			"https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
			"https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/php/php.svg",
			"https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/html/html.svg",
			"https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/javascript/javascript.svg",
			"https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg",
			"https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/css/css.svg",
			"https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg",
		],
		backend: [
			"https://camo.githubusercontent.com/b19864f800e20ca559cd76b53f377ef65249119ce7a8da98becc200f6ef56e30/68747470733a2f2f7365656b6c6f676f2e636f6d2f696d616765732f4e2f6e6f64656a732d6c6f676f2d464245313232453337372d7365656b6c6f676f2e636f6d2e706e67",
			"https://camo.githubusercontent.com/9270fc40ed052b4158b76122cc9984c9c9670b717577d3e89497629fc25782e7/68747470733a2f2f75706c6f61642e77696b696d656469612e6f72672f77696b6970656469612f636f6d6d6f6e732f7468756d622f382f38382f5374617475735f6975636e5f45585f69636f6e2e7376672f34383070782d5374617475735f6975636e5f45585f69636f6e2e7376672e706e67",
			"mongodb.png",
			"mysql.png",
		],
		service: [
			"firebase.png",
			"github.png",
			"netlify.png",
			"https://d4.alternativeto.net/PppvJ_W7_KwSS1FOuGpbvedVX6rNX7iMO7ET6OAHXtE/rs:fill:280:280:0/g:ce:0:0/YWJzOi8vZGlzdC9pY29ucy9yZW5kZXJfMTQ5MzY1LnBuZw.png",
			"namecheap.svg",
			"cloud.svg",
			"https://images.ctfassets.net/fzn2n1nzq965/HTTOloNPhisV9P4hlMPNA/cacf1bb88b9fc492dfad34378d844280/Stripe_icon_-_square.svg?q=80&w=1082",

			"mongodbatlas.svg",
			"jira.svg",
		],
		database: ["mongodbatlas.svg"],
	},
	homepage: {
		title: "Full-Stack Web Developer",
		description:
			"BS in Computer Engineering from the University of Rizal System – Morong Major in Website Development and Database Management. With background knowledge in Web App Development, Database Design, and Implementation of Applications. I have developed various project over the course of the years using various langauge and technologies, I also enjoy solving complex problems and learning new skills.  I am always looking for new challenges and opportunities to grow as a developer",
	},

	about: {
		title: "I’m Von A. I lived in the Philippines, Building a better future",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Cpu Scheduler",
			description:
				"A Web application CPU scheduling that can calculate and generate data such as TurnAroundTime and WaitingTime to ganttchart and table with various algorithm.",

			linkText: "View Project",
			link: "https://cpu-scheduler-online.netlify.app",
			imageData:
				"https://raw.githubusercontent.com/Locality-PH/cpu_scheduler/main/src/screenshot/CPU_SCHEDULER.png",
			logoArray: [
				"https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
			],
		},

		{
			title: "Mitivelane",
			description:
				"I am the lead developer of my thesis for  MitiveLane's Customer Data Platform (CDP), which enables efficient management, provision, collection, and categorization of data groups specific to your designated area.",

			logoArray: [
				"https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
				"nodejs.png",
				"mongodbatlas.svg",
			],

			linkText: "View Project",
			link: "https://mitivelane-test.online/",
			imageData: "mitive.jpg",
		},

		{
			title: "GenBioScope",
			description:
				"GenBioScope is a web-based modular application thoughtfully designed for students and teachers. It is a study space to connect with classes, read and download modules, and do activities and quizzes completely for Biology subject.",
			logoArray: [
				"https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
				"nodejs.png",
				"mongodbatlas.svg",
			],

			linkText: "View Project",
			link: "https://genbioscope.netlify.app/",
			imageData:
				"https://raw.githubusercontent.com/Locality-PH/biology_frontend/main/src/assets/img/screenshot.png",
		},

		{
			title: "Aquaponic - IoT",
			description:
				"An innovative IoT-based aquaponic system that combines aquaculture and hydroponics, leveraging smart sensors and automation to monitor and optimize the growth of fish and plants",
			imageData:
				"https://raw.githubusercontent.com/vonypeto/front-end-aquaponic/main/src/screenshot/screenshot.png",
			linkText: "View Project",
			link: "https://github.com",
			logoArray: [
				"https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
				"nodejs.png",
				"mongodbatlas.svg",
				"https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/c/c.svg",
			],
		},

		// {
		// 	title: "Project 5",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// 	logoArray: [],
		// },
	],
};

export default INFO;
